// extracted by mini-css-extract-plugin
var _1 = "SimulatorElement_disabled__5c973";
var _2 = "SimulatorElement_img__e7e70";
var _3 = "SimulatorElement_preview__c4415";
var _4 = "SimulatorElement_root__f9810";
export { _1 as "disabled", _2 as "img", _3 as "preview", _4 as "root" }
